import classNames from 'classnames/bind';
import React, { useRef, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import { FieldNumber } from '@/components/ui/kit/Field';
import Select from '@/components/ui/kit/Select';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const [action, setAction] = useState();
  const domRefs = useRef({
    gripper: useRef(),
  }).current;

  useEffect(() => {
    domRefs.gripper.current.value = command.data.gripper;
    setAction(command.data.action);
  }, [command.data]);

  const handleBlur = (e) => {
    const name = e.target.name;
    const value = Number(Math.trunc(e.target.value));
    dispatch(actions.mission.updateCommand(index, name, value));
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Gripper Instance Number">
        <FieldNumber ref={domRefs.gripper} name="gripper" min={1} onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Action">
        <Select name="action" value={action} onChange={handleBlur} className={cx('select')}>
          <option value={0}>Release</option>
          <option value={1}>Grab</option>
        </Select>
      </FieldRow>
    </div>
  );
};

export default Command;
